import {
  tooltipFormatter,
  tooltipValueOnlyFormatter,
} from "@src/cloud-connect/utils/graph-formatters";
import { ToolboxBuilder } from "@src/cloud-connect/charts/toolbox-builder";
import { GridBuilder } from "@src/cloud-connect/charts/grid-builder";
import { XAxisBuilder } from "@src/cloud-connect/charts/xaxis-builder";
import { formatDateTimeForGraphLabel } from "@src/cloud-connect/utils/format-date-time-for-graph-label";

interface BuildGraphOptionObjectArgs {
  nodeName: string;
  valuesArray: any[];
  timesArray: any[];
  yAxisMin: number | string;
  yAxisMax: number | string;
  zoomStart: number;
  unitDisplayName: string;
  showDataZoom?: boolean;
  valueOnly?: boolean;
}

export const buildGraphOptionObject = ({
  nodeName,
  valuesArray,
  timesArray,
  yAxisMin,
  yAxisMax,
  zoomStart,
  unitDisplayName,
  showDataZoom = false,
  valueOnly = false,
}: BuildGraphOptionObjectArgs) => {
  const graphOptions = {
    grid: new GridBuilder().setBottom(100).build(),
    toolbox: new ToolboxBuilder()
      .withDataView()
      .withSaveAsImage({ name: nodeName })
      .build(),
    xAxis: new XAxisBuilder()
      .setData(timesArray)
      .setFormatter(formatDateTimeForGraphLabel)
      .setBoundaryGap(false)
      .build(),
    yAxis: {
      name: unitDisplayName,
      type: "value",
      /* min: Math.min(...valuesArray),
      max: Math.max(...valuesArray), */
      scale: true,
      axisLine: {
        onZero: true,
      },
      nameTextStyle: {
        padding: [-11, 0, 0, -20],
        verticalAlign: "top",
        align: "left",
      },
      /* axisLabel: {
        formatter: manipulateValue,
      }, */
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(255, 255, 255, 0.3)", // Semi-transparent background
      confine: true,
      borderColor: "gray",
      borderWidth: 1,
      textStyle: {
        fontFamily: "Inter",
      },
      formatter: valueOnly ? tooltipValueOnlyFormatter : tooltipFormatter,
      extraCssText:
        "backdrop-filter: blur(5px); padding: 15px 20px 10px; box-sizing: border-box;",
    },
    dataZoom: [
      {
        show: showDataZoom,
        realtime: true,
        start: zoomStart,
        end: 100,
        xAxisIndex: [0, 1],
        textStyle: {
          color: "transparent",
          fontSize: 0,
        },
      },
      {
        show: showDataZoom,
        realtime: true,
        start: zoomStart,
        end: 100,
        xAxisIndex: [0, 1],
        textStyle: {
          color: "transparent",
          fontSize: 0,
        },
      },
    ],
    series: {
      data: valuesArray.map((v: any) => ({ value: v })),
      type: "line",
      smooth: 0.4,
      lineStyle: {
        color: "#027680",
        width: 2,
      },
      symbol: "circle",
      symbolSize: 8,
      showSymbol: valuesArray.length === 1 ? true : false,
      itemStyle: {
        color: "#3aacc8",
      },
      areaStyle: null,
      animation: true,
      animationDuration: 1000,
      animationEasing: "quadraticIn",
      animationDelay: 0,
      connectNulls: true,
    },
  };

  return graphOptions;
};
